angular.module('files')
    .factory('Folder', function ($resource) {
        return $resource('/crm/api/folders/:id', {id: '@id'}, {
            update: {method: 'PUT'}
        });
    })
    .service('FolderService', function (toastr, modals, Folder) {
        this.folderEditModal = folder => modals.open('app/files/edit-folder-modal.html', 'FolderEditCtrl', folder, {size: "md"}, "$ctrl");
        this.deleteFolderModal = item => {
            return modals.confirmDelete(`folder ${item.name} razem z podfolderami`, () => Folder.delete({id: item.id}).$promise);
        };
        this.addSubfolderModal = folder => modals.open('app/files/edit-folder-modal.html', 'FolderEditCtrl', folder, {size: "md"}, "$ctrl");
        this.formatFolders = folders => formatFoldersRecursive(folders);

        function formatFoldersRecursive(folders) {
            angular.forEach(folders, f => {
                f.label = f.name;
                f.children = f.subfolders;
                formatFoldersRecursive(f.subfolders);
            });
        }
    })
    .controller('FolderEditCtrl', function ($rootScope, $uibModalInstance, data, Folder, toastr) {
        this.item = data;
        this.cancel = () => $uibModalInstance.dismiss('Canceled')

        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = Folder.update(this.item).$promise
            } else {
                promise = Folder.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast("folder.updated", result)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
